export default function(esinp, exp) {
  return (Math.pow((1 - esinp) / (1 + esinp), exp));
}


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/proj4/lib/common/srat.js
// module id = ../../../../proj4/lib/common/srat.js
// module chunks = vendor